document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('kave-pro-form');
  if (!form) return;

  const body = form.closest('.account-forms__controller__body');
  const successEl = body.querySelector('[data-pro-success]');
  const errorEl = body.querySelector('[data-pro-error]');
  const submitBtn = form.querySelector('button');

  body.querySelector('[data-pro-retry]')?.addEventListener('click', () => {
    errorEl.hidden = true;
    form.hidden = false;
    submitBtn.disabled = false;
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    submitBtn.disabled = true;

    const payload = {
      shop: form.dataset.shop,
      customerId: form.dataset.customerId,
      phone: formData.get('phone') || undefined,
      companyName: formData.get('company_name'),
      address: formData.get('address'),
      postalCode: formData.get('postal_code'),
      city: formData.get('city'),
      country: formData.get('country'),
      vatCountry: formData.get('vat_country'),
      vatNumber: formData.get('vat_number'),
      sector: formData.get('sector'),
      source: formData.get('source'),
      social: formData.get('social'),
      acceptsMarketing: formData.get('customer[accepts_marketing]') === 'true',
    };

    try {
      const res = await fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error();

      form.hidden = true;
      successEl.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      form.hidden = true;
      errorEl.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});
